"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.testimonialModuleFragment = void 0;
var _fetching = require("@ori/fetching");
const testimonialModuleFragment = exports.testimonialModuleFragment = (0, _fetching.gql)`
  fragment TestimonialModule on EditorialTestimonialCarousel {
    __typename
    id
    collection {
      __typename
      title
      showStarRating
      textCollection {
        __typename
        text
        textLinks {
          id
          relativeUrl
          title
        }
      }
      author
      image {
        __typename
        url
        urlMobile
      }
    }
  }
`;
